import uk from './uk.json';
import eng from './eng.json';

const changeLang = (lang) => {
    switch(lang){
        case "ua": return uk;
        case "eng": return eng;

        default: return uk;
    }
}

export const initializationLang = (lang) => {
    const currentLang = changeLang(lang);
    window.lang = currentLang;
    return currentLang
}